import React from "react";
const IconTick = ({ fill }) => /* @__PURE__ */ React.createElement("svg", {
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React.createElement("path", {
  d: "M15.2803 0.969787C14.9878 0.676537 14.513 0.676537 14.2198 0.969037L5.74327 9.43879L1.78102 5.46979C1.48852 5.17654 1.01377 5.17654 0.72052 5.46904C0.42727 5.76154 0.42727 6.23629 0.71977 6.52954L5.21227 11.0295C5.24902 11.0663 5.28802 11.0985 5.33002 11.1255C5.61577 11.3145 6.00277 11.2868 6.25927 11.043C6.26377 11.0385 6.26827 11.034 6.27277 11.0295L6.27502 11.0273L15.2803 2.02954C15.5735 1.73704 15.5735 1.26154 15.281 0.969037L15.2803 0.969787Z",
  fill: fill || "currentColor"
}));
var IconTick_default = IconTick;
export {
  IconTick_default as default
};
